import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
// import { BehaviorSubject } from 'rxjs';
// import 'rxjs/add/operator/share';
// import 'rxjs/add/operator/startWith';
import { User } from './../../modules/account/login/_models/user.model';

@Injectable()
export class AppGlobal {

    private currentUser: BehaviorSubject<User> = new BehaviorSubject<User>(new User());
    $userAccount: Observable<User>;

    constructor() {
        this.$userAccount = this.currentUser.asObservable();
    }
    setCurrentUser(currentUser) {
        this.currentUser.next(currentUser);
    }

}
